module.exports = "pegasus/assets/themelp1/basic/105.png";